import { CONTENTS_LIST_OPEN } from '@constants/storages'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { create } from 'zustand'

interface ICollapsibleStore {
  isOpen: boolean
  hasUserChoice: boolean
  setIsOpen: (isOpen: boolean) => void
}

// O estado do painel de módulos persiste para a lista voltar como o aluno
// deixou. A persistência é feita à mão com AsyncStorage (localStorage na web,
// mesma API no nativo): NÃO usar zustand/middleware aqui — o módulo ESM embute
// o devtools, que referencia import.meta, e o export web do Metro serve o
// entry como script clássico, onde import.meta é erro de parse do bundle
// inteiro (tela branca em todas as páginas).
export const useCollapsibleStore = create<ICollapsibleStore>((set) => ({
  isOpen: false,
  hasUserChoice: false,
  setIsOpen: (isOpen) => {
    set({ isOpen, hasUserChoice: true })
    AsyncStorage.setItem(CONTENTS_LIST_OPEN, JSON.stringify(isOpen)).catch(
      () => undefined,
    )
  },
}))

// Hidratação async: até resolver vale o default fechado, e um toggle feito
// pelo usuário nesse meio-tempo ganha do valor persistido. Aceita o payload
// bruto (boolean) e o envelope { state: { isOpen } } que a versão anterior
// (middleware persist) chegou a gravar no nativo.
export async function hydrateCollapsibleStore() {
  try {
    const raw = await AsyncStorage.getItem(CONTENTS_LIST_OPEN)
    if (raw === null) return

    const parsed: unknown = JSON.parse(raw)
    const isOpen =
      typeof parsed === 'boolean'
        ? parsed
        : (parsed as { state?: { isOpen?: unknown } } | null)?.state?.isOpen

    if (typeof isOpen !== 'boolean') return
    if (useCollapsibleStore.getState().hasUserChoice) return

    useCollapsibleStore.setState({ isOpen })
  } catch {
    // storage indisponível ou payload inválido: mantém o default fechado
  }
}

hydrateCollapsibleStore()
